import { useContext } from 'react';
import { createContext } from 'react';

import { MinicartProps } from '../@types/MinicartProps';

export const MinicartContext = createContext<MinicartProps>({} as MinicartProps);

MinicartContext.displayName = 'Minicart';

const MinicartProvider = (props: MinicartProps) => (
	<MinicartContext.Provider value={props}>{props.children}</MinicartContext.Provider>
);

export const useMinicart = () => {
	const context = useContext(MinicartContext);

	return context;
};

export default MinicartProvider;
